import React from 'react'
import { Text, VStack, Heading, Skeleton } from '@chakra-ui/react'
import { Card } from 'components'

export const ReportScoreCard = ({ loading, report, ...props }) => (
  <Card {...props} justify='center'>
    <VStack>
      <Heading size='lg'>Score</Heading>
      {loading ? (
        <Skeleton width='80px' height='54px' />
      ) : (
        <Text fontSize='5xl'>{(report?.score * 100)?.toFixed(0)}</Text>
      )}
    </VStack>
  </Card>
)

export default ReportScoreCard
